import { isValidToken } from 'auth/AuthorizationProvider';
import axios from 'axios';
import { endpoint } from 'constants/endpoints';

export const login = async (
  username: string,
  password: string
): Promise<any | Error> => {
  try {
    const result = await axios.post(`${endpoint.LOGIN}`, {
      username,
      password,
    });

    if (result.status === 401) {
      throw Error('Invalid username or password');
    }

    if (result.status !== 200) {
      throw Error('Invalid username or password');
    }

    if (!isValidToken(result.data)) {
      throw Error('Invalid username or password');
    }

    return result.data;
  } catch (error: any) {
    if (error.response) {
      throw Error('Invalid username or password');
    } else if (error.message) {
      throw Error('Invalid username or password');
    } else {
      throw Error('Network Error');
    }
  }
};
